import { useCallback, useEffect } from 'react';

import mixpanel from 'mixpanel-browser';

import { ExperimentsConfig } from '../utils/experiments';
import { KAMELEOON_FEATURE, sendFeatureToMixPanel } from '../utils/kameleoon';

import { useKameleoonFeature } from './useKameleoon';

interface useSetVariantsProps {
    applicationEmail: string;
    hasSecondApplicant: boolean;
    setDeferredApplicant2TestUser: (v: boolean | null) => void;
}

export const useSetVariants = ({
    applicationEmail,
    hasSecondApplicant,
    setDeferredApplicant2TestUser,
}: useSetVariantsProps) => {
    const getA2DeferVariationKey = useKameleoonFeature(
        KAMELEOON_FEATURE.a2_defer,
    );

    const checkKameleoonVariant = useCallback(
        async (
            featureKey: string,
            condition: boolean,
            getVariant: (email: string) => Promise<string | null>,
            setVariantState: (value: boolean) => void,
        ) => {
            if (!condition) return;

            const variant = await getVariant(applicationEmail);

            setVariantState(variant === ExperimentsConfig.Variants.B);
            if (variant !== null) {
                mixpanel.register({ a2_defer_variant: variant });
            }
            sendFeatureToMixPanel(variant, featureKey);
        },
        [applicationEmail],
    );

    useEffect(() => {
        checkKameleoonVariant(
            KAMELEOON_FEATURE.a2_defer,
            hasSecondApplicant,
            getA2DeferVariationKey,
            setDeferredApplicant2TestUser,
        );
    }, [
        hasSecondApplicant,
        getA2DeferVariationKey,
        setDeferredApplicant2TestUser,
        checkKameleoonVariant,
    ]);
};
